import { render } from "./Ethnic_Minority.vue?vue&type=template&id=40b6bc40&ts=true"
import script from "./Ethnic_Minority.vue?vue&type=script&lang=ts"
export * from "./Ethnic_Minority.vue?vue&type=script&lang=ts"

import "./Ethnic_Minority.vue?vue&type=style&index=0&id=40b6bc40&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__